import request from '@/utils/request'

// 路珠 api

export const getRoadBallCount = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/roadBallCount`,
    method: 'get',
    params: query
  })
}
